import React, { useEffect, useState, useRef } from "react";
import { MapContainer, GeoJSON, Marker, Popup, ScaleControl, Polygon, useMapEvents } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import "./RecentEarthquake.css";
import L from "leaflet";
import { center, INITIAL_VIEW_STATE, styleStrike, styleDip, styleDepth, styleTectonicPlate, getColor, getColorUSGS, compute_magnitude, compute_magnitudeUSGS, styleUnitSources, getDistance } from '../recentEqUtils.js';
import * as toGeoJSON from "@tmcw/togeojson";
import { Button, Modal, Form } from 'react-bootstrap';
import "leaflet.heat";
import moment from 'moment-timezone';
import axios from 'axios';
import { Check } from "lucide-react";
import domtoimage from 'dom-to-image-more';
import { jsPDF } from "jspdf";
import WindyInfoButton from "./InfoButton.js";
import HeatmapLayer from "./HeatMapLayer.js";
import DynamicTileLayer from "./DynamicTileLayer.js";
import BaseMapLayerControl from "./BaseMapLayerControl.js";
import { Legend, LegendUSGS } from "./EarthquakeLegend.js";
import { LanguageModal } from "./LanguageModal.js";
import EarthquakeMarkers from "./EarthquakeMarkersRIMES.js";
import EarthquakeMarkersUSGS from "./EarthquakeMarkersUSGS.js";
import { MapHomeControl } from "../../../common/MapControls/MapControls";
import usePermissions from "../../../../Hooks/usePermissions";
import { drawEarthquakeAdvisory } from "./pdfLayout_EQ.js";
const backendUrl = process.env.REACT_APP_BACKEND_API_URL_LOCAL;
//const backendUrl = process.env.REACT_APP_BACK_URL_L;
const validBasemaps = ["White", "Dark", "Satellite", "Streets"];

const sources = {
    RIMES: [
        {
            name: "RIMES",
            description: "Regional Integrated Multi-Hazard Early Warning System providing climate and disaster information.",
            link: "https://www.rimes.int/",
        },
    ],
    USGS: [
        {
            name: "USGS",
            description: "United States Geological Survey offering scientific information about natural hazards and resources.",
            link: "https://www.usgs.gov/",
        },
    ],
};

const defaultEarthquakeAdvisories = [
    {
        id: 1,
        module_name: "earthquake",
        englishheading: "What to do during an earthquake?",
        englishdescription:
            "<ul><li>Stay as safe as possible during an earthquake. Be aware that some earthquakes are actually foreshocks and a larger earthquake might occur. Minimize your movements to a few steps that reach a nearby safe place and stay indoors until the shaking has stopped and you are sure exiting is safe.</li></ul>",
        tetumheading: "Saida maka atu halo durante rai-nakdoko",
        tetumdescription:
            "<ul><li>Mantein seguru ho posibilidade hotu ne’ebé iha durante rai-nakdoko. Hatene katak rai-nakdoko balun nuda’ar rai-nakdoko antesipadu no tuir mai rai-nakdoko boot liu bele akontese. Minimiza ita nia movimentu sira ba pasu balun to'o iha fatin seguru ne'ebé besik no hela iha uma laran to'o nakdoko para nune’e ho ita fiar katak seguru atu sai.</li></ul>",
        order_no: "1",
        status: "TRUE",
    },
    {
        id: 2,
        module_name: "earthquake",
        englishheading: "If Indoors",
        englishdescription:
            "<ul><li>DROP to the ground, take COVER by getting under a sturdy table or other piece of furniture; and HOLD ON until the shaking stops. If there is no a table or desk near you, cover your face and head with your arms and crouch in an inside corner of the building.</li><li>Protect yourself by staying under the lintel of an inner door, in the corner of a room, under a table or even under a bed.</li><li>Stay away from glass, windows, outside doors and walls, and anything that could fall, (such as lighting fixtures or furniture).</li><li>Stay in bed if you are there when the earthquake strikes. Hold on and protect your head with a pillow, unless you are under a heavy light fixture that could fall. In that case, move to the nearest safe place.</li><li>Use a doorway for shelter only if it is in close proximity to you and if you know it is a strongly supported, load bearing doorway.</li><li>Stay inside until the shaking stops and it is safe to go outside. Research has shown that most injuries occur when people inside buildings attempt to move to a different location inside the building or try to leave.</li><li>Be aware that the electricity may go out or the sprinkler systems or fire alarms may turn on.</li></ul>",
        tetumheading: "Se iha uma laran",
        tetumdescription:
            "<ul><li>TOBA ba rai, SUBAR tama iha meza ne'ebé metin ka mobiliáriu seluk nia okos; no MANTEIN to'o nakdoko para.</li><li>Se laiha meza ka mobiliáriu besik ita, taka ita nia oin no ulun ho ita-boot nia liman no hakru'uk iha edifísiu nia kantu sira.</li><li>Hadook an husi vidru, janela, odamatan liur no parede, no buat hotu ne’ebé bele monu, hanesan lampu ka mobiliáriu.</li><li>Mantein iha kama se ita iha ne'ebá bainhira rai-nakdoko akontese. Kaer metin no proteje ita nia ulun ho sumasu, exeptu ita iha lampu ne'ebé boot nia okos ne'ebé bele monu. Iha kazu ne'ebá, muda ba fatin seguru ne'ebé besik liu.</li><li>Uza odamatan ida de'it ba abrigu se ida-ne'e besik no ida-ne'e maka odamatan ida ne'ebé hetan apoiu maka'as, no bele tahan todan.</li><li>Mantein iha laran to'o nakdoko para no seguru atu sai ba liur.</li><li>Konsiente katak eletrisidade bele mate ka alarme aspersaun/ahi nian bele lakan.</li></ul>",
        order_no: "2",
        status: "TRUE",
    },
    {
        id: 3,
        module_name: "earthquake",
        englishheading: "If outdoors",
        englishdescription:
            "<ul><li>Do not move from where you are. However, move away from buildings, trees, streetlights, and utility wires.</li><li>If you are in open space, stay there until the shaking stops. The greatest danger exists directly outside buildings; at exits; and alongside exterior walls. Most earthquake-related casualties result from collapsing walls, flying glass, and falling objects.</li></ul>",
        tetumheading: "Se iha liur",
        tetumdescription:
            "<ul><li>Labele muda hosi fatin ne'ebé ita iha ba. Maibé, hadook-an hosi edifísiu sira, ai-hun sira, lampu sira iha dalan, no fiu sira.</li><li>Se ita iha fatin luan, hela iha ne'ebá to'o nakdoko para. Perigu boot liu eziste diretamente iha edifísiu sira nia liur; iha saída sira; no iha parede sira iha liur nia sorin. Maioria vítima sira ne'ebé relasiona ho rai-nakdoko rezulta hosi parede sira ne'ebé monu, vidru sira ne'ebé semo, no sasán sira ne'ebé monu.</li></ul>",
        order_no: "3",
        status: "TRUE",
    },
    {
        id: 4,
        module_name: "earthquake",
        englishheading: "If in a moving vehicle",
        englishdescription:
            "<ul><li>Do not move from where you are. However, move away from buildings, trees, streetlights, and utility wires.</li><li>If you are in open space, stay there until the shaking stops. The greatest danger exists directly outside buildings; at exits; and alongside exterior walls. Most earthquake-related casualties result from collapsing walls, flying glass, and falling objects.</li></ul>",
        tetumheading: "Se iha kareta ne'ebé la'o hela",
        tetumdescription:
            "<ul><li>Para lalais bainhira seguransa permite no hela iha veíkulu laran. Evita para besik ka iha edifísiu nia okos, ai-hun sira, no fiu sira.</li><li>Bele kontinua viajen ho kuidadu bainhira rai-nakdoko para ona. Evita estrada, ponte, ka rampa sira ne'ebé maka hetan ona estragu tanba rai-nakdoko.</li></ul>",
        order_no: "4",
        status: "TRUE",
    },
    {
        id: 5,
        module_name: "earthquake",
        englishheading: "If trapped under debris",
        englishdescription:
            "<ul><li>Do not light a match.</li><li>Do not move about or kick up dust.</li><li>Cover your mouth with a handkerchief or clothing.</li><li>Tap on a pipe or wall so rescuers can locate you. Use a whistle if one is available. Shout only as a last resort. Shouting can cause you to inhale dangerous amounts of dust.</li></ul>",
        tetumheading: "Metin tia iha rai-rahun sira",
        tetumdescription:
            "<ul><li>Labele sunu ahi.</li><li>Labele movimenta ka hasai rai-rahun.</li><li>Taka ita-boot nia ibun ho lensu ka roupa.</li><li>Kaer ba kanu ka parede ida atu nune'e salvadór sira bele lokaliza ita-boot. Uza apitu ida se ida disponivel. Hakilar de'it hanesan rekursu ikus liu. Hakilar bele halo ita-boot dada iis ho kuantidade rai-rahun ne'ebé perigozu.</li></ul>",
        order_no: "5",
        status: "TRUE",
    },
];

//const backendUrl = process.env.BACKEND_API_URL_LOCAL;
const HoverCoordinates = ({ setCoordinates }) => {
    useMapEvents({
        mousemove: (event) => {
            const { lat, lng } = event.latlng;
            setCoordinates({ lat: lat.toFixed(4), lng: lng.toFixed(4) });
        },
    });
    return null;
};

const RecentEarthquake = () => {
    const { hasPermission } = usePermissions();
    const canSendEmail = hasPermission('earthquake_recent_earthquake_send_email');
    const canGenerateBulletin = hasPermission('earthquake_recent_earthquake_bulletin');
    const [selectedSource, setSelectedSource] = useState("RIMES");
    const [coordinates, setCoordinates] = useState({ lat: null, lng: null });
    const [show, setShow] = useState(false);
    const [modal_message_info, setmodal_message_info] = useState(null);
    const [modalRegion, setModalRegion] = useState(null);
    const [emailSource, setEmailSource] = useState(null);
    const [mapImage, setMapImage] = useState(null);
    const mapRef = useRef(null);
    const [selectedEventDetails, setSelectedEventDetails] = useState(null);

    const [showLanguageModal, setShowLanguageModal] = useState(false);
    const [/*selectedLanguage*/, setSelectedLanguage] = useState(null);
    const [clickedEventElement, setClickedEventElement] = useState(null);

    const handleShowModal = (e) => {
        const m_info = e.target.getAttribute("data-info");
        const regInfo = e.target.getAttribute("data-reg");
        const sourceInfo = e.target.getAttribute("data-source");

        const mapElement = mapRef.current;

        const button = e.currentTarget;
        const dataset = button.dataset;

        const source = dataset.source;
        let eventDetails = {};

        if (source === 'USGS') {
            eventDetails = {
                source,
                title: dataset.title,
                region: dataset.reg,
                magnitude: dataset.magnitude,
                mag_type: dataset.magt?.toLowerCase() === "mb" ? "SR" : dataset.magt,
                depth: dataset.depth,
                latitude: dataset.lat,
                longitude: dataset.long,
                time_utc: dataset.utctime,
                time_tlt: dataset.tlttime,
                tsunami: dataset.tsunami,
                felt: dataset.felt,
                cdi: dataset.cdi,
                mmi: dataset.mmi,
                alert: dataset.alert,
                significance: dataset.sig,
                full_message: dataset.info,
            };
        } else if (source === 'RIMES') {
            eventDetails = {
                source,
                region: dataset.reg,
                magnitude: dataset.mag,
                mag_type: dataset.magt?.toLowerCase() === "mb" ? "SR" : dataset.magt,
                depth: dataset.depth,
                latitude: dataset.lat,
                longitude: dataset.long,
                time_tlt: dataset.time,
                full_message: dataset.info,
            };
        }

        console.log(eventDetails);
        // Set this to state or pass to modal
        setSelectedEventDetails(eventDetails);
        //return;
        if (mapElement) {
            domtoimage.toPng(mapElement)
                .then((dataUrl) => {
                    setMapImage(dataUrl); // Save the base64 image
                    setmodal_message_info(m_info);
                    setModalRegion(regInfo);
                    setEmailSource(sourceInfo);

                    setShow(true); // Open modal after image is captured
                })
                .catch((error) => {
                    console.error("Error capturing map image:", error);
                    // Fallback: Open modal even if image fails
                    setmodal_message_info(m_info);
                    setModalRegion(regInfo);
                    setEmailSource(sourceInfo);
                    setShow(true);
                });
        } else {
            setmodal_message_info(m_info);
            setModalRegion(regInfo);
            setEmailSource(sourceInfo);
            setShow(true);
        }
    };

    const handleCloseModal = () => {
        setShow(false);
        setSelectedOption('');
    };

    //const handleClose = () => setShow(false);
    //const handleShow = () => setShow(true);
    const [boundaryData, setBoundaryData] = useState(null);
    const [slab_depth, setSlab_depth] = useState(null);
    const [slab_dip, setSlab_dip] = useState(null);
    const [slab_strike, setSlab_strike] = useState(null);
    const [tectonicPlate, setTectonicPlate] = useState(null);
    const [buffer200, setBuffer200] = useState(null);
    const [L_IOC, setL_IOCData] = useState(null);
    const [Unit_Source, setL_UNITSource] = useState(null);
    const [EQHistory, setEQHistory] = useState(null);
    const [EQHistoryUSGS, setEQHistoryUSGS] = useState(null);
    const [, setError] = useState(null);
    const [selFeDIP, setselFeDIP] = useState(null);
    const [selFeDepth, setselFeDepth] = useState(null);
    const [selFeStrike, setselFeStrike] = useState(null);
    const [selectedOption, setSelectedOption] = useState('');
    const [, setEarthquakeAdvisories] = useState(defaultEarthquakeAdvisories);
    // const URLTILEMAP_WHITE = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    //     URLTILEMAP_BLACK = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    //     URLTILEMAP_SATELLITE = "https://mt1.google.com/vt/lyrs=y&x={x}&y={y}&z={z}",
    //     URLTILEMAP_OSM = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

    const recentEqURL = `${backendUrl}EarthQuake/eq_events/`;
    const recentEqUSGSURL = `${backendUrl}EarthQuake/eq_events_usgs/`;
    const nearbyCitiesURL = `${backendUrl}EarthQuake/getNearbyCitiesofaEvent/`;
    const earthquakeAdvisoryURL = `${backendUrl}EarthQuake/earthquake-advisories/`;
    const [reEqdata, setReEqData] = useState([]);
    const [reEqUSGSdata, setReEqUSGSData] = useState([]);
    const markerRefs = useRef([]); // Array to hold references to markers

    const [selectedGroupId, setSelectedGroupId] = useState('');
    const [groupEmails, setGroupEmails] = useState([]);

    const handleExternalClick = (index) => {
        setSelectedEventIndex(index);
        if (markerRefs.current[index]) {
            markerRefs.current[index].openPopup(); // Open the popup for the specific marker
        }
    };

    const [ /*showModal */, setShowModal] = useState(false);
    const [nearbyCities, setNearbyCities] = useState([]);
    const [/*loading */, setLoading] = useState(false);
    const [isSendingEmail, setIsSendingEmail] = useState(false);

    // Custom Icon
    const customIcon = L.icon({
        iconUrl: "/DATA/earthquake/marker_white.png", // Replace with your custom icon URL
        iconSize: [30, 30], // Size of the icon
    });
    const onEachFeatureSlabDip = (feature, layer) => {
        layer.on({
            mouseover: () => {
                setselFeDIP(` <table className="table-popup"> <tbody>
                    <tr className="centeralign">
                        <th colspan="2">Slab DIP</th>
                    </tr>
                    <tr>
                        <th>Region : </th>
                        <td>${feature.properties.REGION}</td>
                    </tr>
                    <tr>
                        <th>Dip : </th>
                        <td>${feature.properties.DIP} °</td>
                    </tr>
                    </tbody> </table>`)
            },
            mouseout: () => {
                setselFeDIP(null);
            }
        });
    };

    const onEachFeatureSlabDepth = (feature, layer) => {
        layer.on({
            mouseover: () => {
                setselFeDepth(` <table className="table-popup slabDepthCls"> <tbody>
                        <tr className="centeralign">
                            <th colspan="2">Slab Depth</th>
                        </tr>
                        <tr>
                            <th>Region : </th>
                            <td>${feature.properties.REGION}</td>
                        </tr>
                        <tr>
                            <th>Depth : </th>
                            <td>${feature.properties.DEPTH} km</td>
                        </tr>
                        </tbody> </table>`)
            },
            mouseout: () => {
                setselFeDepth(null);
            }
        });
    };

    const onEachFeatureSlabStrike = (feature, layer) => {
        layer.on({
            mouseover: () => {
                setselFeStrike(` <table className="table-popup"> <tbody>
                    <tr className="centeralign">
                        <th colspan="2">Slab Strike</th>
                    </tr>
                    <tr>
                        <th>Region : </th>
                        <td>${feature.properties.REGION}</td>
                    </tr>
                    <tr>
                        <th>Strike : </th>
                        <td>${feature.properties.STRIKE} km</td>
                    </tr>
                    </tbody> </table>`)
            },
            mouseout: () => {
                setselFeStrike(null);
            }
        });
    };

    const [/*enableSimulation */, setEnableSimulation] = useState(false);
    const [/*enableAreaofRes*/, setAreaofRes] = useState(false);
    const [/*enableAreaofInterest*/, setAreaofInterest] = useState(false);
    const [/*enable200KmBuffer*/, set200KmBuffer] = useState(false);
    const [/*enableUnitSource*/, setUnitSource] = useState(false);
    const [/*enableIOCSeaLevel*/, setIOCSeaLevel] = useState(false);
    const [/*enableHeatmap*/, setHeatmap] = useState(false);
    const [/*enableFaultLine*/, setFaultLine] = useState(false);
    const [/*enableSlabStrike*/, setSlabStrike] = useState(false);
    const [/*enableSlabDip*/, setSlabDip] = useState(false);
    const [/*enableSlabDepth*/, setSlabDepth] = useState(false);
    const [numberOfEQ, setNumberOfEQ] = useState(false);
    const [selectedEventIndex, setSelectedEventIndex] = useState(0);
    const [basemap, setBasemap] = useState('White');
    const [minMagnitude, setMinMagnitude] = useState(2.5);
    // const [email, setEmail] = useState('saroj@rimes.int');

    const [leafletCoordinates, setLeafletCoordinates] = useState([]);
    const [/*aoiGeoJson*/, setAoiGeoJson] = useState(null);

    // Fetch Recent EQ From RIMES URL
    useEffect(() => {
        const fetchData = async () => {
            try {
                const params = new URLSearchParams();
                if (numberOfEQ) params.set('number_of_eq', numberOfEQ);
                if (minMagnitude) params.set('min_magnitude', minMagnitude);
                const url = params.toString() ? `${recentEqURL}?${params.toString()}` : recentEqURL;
                const response = await fetch(url);
                const data = await response.json();
                setReEqData(data);
            } catch (err) {
                setError(err.message);
            }
        };
        fetchData();
        const intervalId = setInterval(() => {
            fetchData();
        }, 60000); // 60000 ms = 1 minute
        return () => clearInterval(intervalId);
    }, [numberOfEQ, minMagnitude, recentEqURL]);
    // Fetch Recent EQ From RIMES URL -END

    // Fetch Recent EQ From USGS URL
    useEffect(() => {
        if (!minMagnitude) return;
        const fetchData = async () => {
            try {
                const base = `${recentEqUSGSURL}?min_magnitude=${minMagnitude}`;
                const url = numberOfEQ ? `${base}&number_of_eq=${numberOfEQ}` : base;
                const response = await fetch(url);
                const data = await response.json();
                setReEqUSGSData(data);
            } catch (err) {
                setError(err.message);
            }
        };
        fetchData();
        const intervalId = setInterval(() => {
            fetchData();
        }, 60000); // 60000 ms = 1 minute
        return () => clearInterval(intervalId);
    }, [minMagnitude, numberOfEQ, recentEqUSGSURL]);
    // Fetch Recent EQ From USGS URL -END

    // Fetch Near BY cities of a event by event id 
    const fetchNearbyCities = async (eventId) => {
        setLoading(true);
        setShowFlashMsg(false)
        try {
            const response = await fetch(`${nearbyCitiesURL}/${eventId}`); // Replace with a real API endpoint
            const data = await response.json();
            console.log(data.records.length);
            setNearbyCities(data.records || []);
            if (data.records.length === 0) {
                handleShowMessage();
            }
        } catch (error) {
            console.error('Error fetching nearby cities:', error);
        }
        setLoading(false);
        setShowModal(true);
    };

    const [showFlashMsg, setShowFlashMsg] = useState(false);

    const handleShowMessage = () => {
        setShowFlashMsg(true);
        setTimeout(() => setShowFlashMsg(false), 5000); // Hide after 5 sec
    };

    useEffect(() => {
        const fetchEarthquakeAdvisories = async () => {
            try {
                const response = await axios.get(earthquakeAdvisoryURL);
                if (Array.isArray(response.data) && response.data.length) {
                    const sorted = [...response.data].sort((a, b) => {
                        const orderA = parseFloat(a?.order_no) || 0;
                        const orderB = parseFloat(b?.order_no) || 0;
                        return orderA - orderB;
                    });
                    setEarthquakeAdvisories(sorted);
                }
            } catch (error) {
                console.error("Error fetching earthquake advisories:", error);
            }
        };
        fetchEarthquakeAdvisories();
    }, [earthquakeAdvisoryURL]);

    const stripHtmlTags = (htmlString) => {
        if (!htmlString || typeof htmlString !== "string") {
            return "";
        }
        return htmlString.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    };

    const extractBulletPoints = (htmlContent) => {
        if (!htmlContent || typeof htmlContent !== "string") {
            return [];
        }
        if (typeof window === "undefined" || typeof document === "undefined") {
            const fallback = stripHtmlTags(htmlContent);
            return fallback ? [fallback] : [];
        }
        const container = document.createElement("div");
        container.innerHTML = htmlContent;
        const items = container.querySelectorAll("li");
        if (!items.length) {
            const text = container.textContent?.trim();
            return text ? [text] : [];
        }
        return Array.from(items)
            .map((node) => node.textContent.trim())
            .filter(Boolean);
    };

    const formatAdvisoryDescription = (htmlContent) => {
        const bullets = extractBulletPoints(htmlContent);
        if (!bullets.length) {
            const fallback = stripHtmlTags(htmlContent);
            return fallback || "Information not available.";
        }
        return bullets.map((point) => `• ${point}`).join("\n\n");
    };

    const buildAdvisoryHeading = (section, index, language = "en") => {
        if (!section) {
            return `Advisory ${index + 1}`;
        }
        const primaryKey = language === "tet" ? "tetumheading" : "englishheading";
        const fallbackKey = language === "tet" ? "englishheading" : "tetumheading";
        return (
            section[primaryKey]?.trim() ||
            section[fallbackKey]?.trim() ||
            `Advisory ${index + 1}`
        );
    };


    useEffect(() => {
        // Load the GeoJSON boundary data
        fetch("/DATA/OSMbased_adm2_boundary.json")
            .then((response) => response.json())
            .then((data) => setBoundaryData(data))
            .catch((error) => console.error("Error loading boundary data:", error));
    }, []);
    useEffect(() => {
        fetch("/Earthquake/slab_depth.geojson")
            .then((response) => response.json())
            .then((data) => setSlab_depth(data))
            .catch((error) => console.error("Error loading slab depth data:", error));
    }, []);
    useEffect(() => {
        fetch("/Earthquake/slab_dip.geojson")
            .then((response) => response.json())
            .then((data) => setSlab_dip(data))
            .catch((error) => console.error("Error loading slab dip data:", error));
    }, []);
    useEffect(() => {
        fetch("/Earthquake/slab_strike.geojson")
            .then((response) => response.json())
            .then((data) => setSlab_strike(data))
            .catch((error) => console.error("Error loading slab strike data:", error));
    }, []);

    // Tectnoic Plates - START
    useEffect(() => {
        fetch('https://raw.githubusercontent.com/fraxen/tectonicplates/master/GeoJSON/PB2002_boundaries.json')
            .then((response) => response.json())
            .then((data) => setTectonicPlate(data))
            .catch((error) => console.error("Error loading slab strike data:", error));
    }, []);
    // Tectnoic Plates - END

    // UNIT Source
    useEffect(() => {
        const fetchKML = async () => {
            try {
                const response = await fetch("/Earthquake/unitsource.kml"); // Replace with your file path
                const kmlText = await response.text();
                const parser = new DOMParser();
                const kml = parser.parseFromString(kmlText, "text/xml");
                const geoJson = toGeoJSON.kml(kml);
                setL_UNITSource(geoJson); // Set the converted GeoJSON data
            } catch (error) {
                console.error("Error loading KML file:", error);
            }
        };
        fetchKML();
    }, []);
    // UNIT Source - END
    // Display IOC LEVEL DATA - START
    useEffect(() => {
        const fetchKML = async () => {
            try {
                const response = await fetch("/Earthquake/gml.kml"); // Replace with your file path
                const kmlText = await response.text();
                const parser = new DOMParser();
                const kml = parser.parseFromString(kmlText, "text/xml");
                const geoJson = toGeoJSON.kml(kml);
                setL_IOCData(geoJson); // Set the converted GeoJSON data
            } catch (error) {
                console.error("Error loading KML file:", error);
            }
        };
        fetchKML();
    }, []);
    // Display IOC LEVEL DATA - END

    // EQ History - START
    // useEffect(() => {
    //     fetch('/Earthquake/eq_history.js')
    //     .then((response) => response.json())
    //     .then((data) => setEQHistory(data))
    //     .catch((error) => console.error("Error loading EQ History data:", error));
    // }, []);
    // EQ History - END

    // BufferZone 200km - START
    useEffect(() => {
        fetch('/Earthquake/buffer_200km.geojson')
            .then((response) => response.json())
            .then((data) => setBuffer200(data))
            .catch((error) => console.error("Error loading Buffer zone data:", error));
    }, []);
    // BufferZone 200km - END

    // Handle option change
    const handleOptionChange = (e) => {
        setSelectedOption(e.target.value);
    };

    // Create refs for each form field
    const refSentTo = useRef(null);
    const refMessage = useRef(null);
    const sendEmail = async (e) => {
        e.preventDefault();
        setIsSendingEmail(true); // Start loading
        if (!refMessage.current) {
            alert("Message field is missing.");
            return;
        }
        const message = refMessage.current.value;
        let emailList = [];
        if (selectedOption === '1') {
            if (!refSentTo.current) {
                alert("Email input is missing.");
                return;
            }
            const toEmail = refSentTo.current.value;
            emailList = toEmail.split(',').map(email => email.trim());
        } else if (selectedOption === '3') {
            if (groupEmails.length === 0) {
                alert("No emails found for the selected group.");
                return;
            }
            emailList = groupEmails;
        } else {
            alert("Please select a valid recipient option.");
            return;
        }

        const emailData = {
            custom_message: message,
            user_email: emailList,
            subject: `*** Earthquake Advisory *** - ${emailSource}`,
            map_image: mapImage,
            earthquake_details: [selectedEventDetails], // ← send as array
        };
        e.preventDefault();

        try {
            const response = await axios.post(`${backendUrl}common/send-email/`, emailData, {
                //const response = await axios.post(`http://127.0.0.1:8000/common/send-email/`, emailData, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            //alert(response.data.status);
            alert("Email sent successfully!", response);
            setShow(false);
        } catch (error) {
            alert(error.response.data.error || "Failed to send email.");
            setShow(false);
        } finally {
            setIsSendingEmail(false); // End loading
        }
    };

    // Fetch Email group data from Django API
    const [emailGroups, setEmailGroups] = useState([]);
    const fetchGroupData = async () => {
        try {
            const response = await fetch(`${backendUrl}AutoEmail/auto_email_user_groups/`);
            const result = await response.json();
            setEmailGroups(result.groups);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
        }
    };
    useEffect(() => {
        fetchGroupData();
    }, []);
    // End of Fetching email group

    // fetching municipality and submunicipality from the db -- START
    const [municipalities, setMunicipalities] = useState([]);
    const [subMunicipalities, setSubMunicipalities] = useState([]);
    const [selectedMunicipality, setSelectedMunicipality] = useState("");
    useEffect(() => {
        //fetch('http://127.0.0.1:8000/api/get-municipalities/') // Django API endpoint
        axios.post(`${backendUrl}Municipalities/municipalities_list/`)
            .then(response => response.data)
            .then(data => setMunicipalities(data))
            .catch(error => console.error('Error fetching municipalities:', error));
    }, []);

    useEffect(() => {
        if (selectedMunicipality) {
            axios.post(`${backendUrl}Municipalities/sub_municipalities_list/`,
                { adm1_code: selectedMunicipality })
                .then((response) => {
                    setSubMunicipalities(response.data);
                })
                .catch((error) => {
                    console.error('Error fetching sub-municipalities:', error);
                });
        } else {
            setSubMunicipalities([]);
        }
    }, [selectedMunicipality]);

    const handleMunicipalityChange = (e) => {
        setSelectedMunicipality(e.target.value);
    };
    // fetching municipality and submunicipality from the db -- END


    const handleLanguageSelection = (lang) => {
        setSelectedLanguage(lang);
        setShowLanguageModal(false);
        if (clickedEventElement) {
            captureAndUploadImage(lang, clickedEventElement);
        }
    };

    const captureAndUploadImage = (language, clickedElement) => {
        if (!mapRef.current) return;
        const sourceInfo = clickedElement.getAttribute("data-source");
        //alert(sourceInfo);
        domtoimage.toPng(mapRef.current)
            .then((dataUrl) => {
                let eventData = {};
                if (sourceInfo === "RIMES") {
                    eventData = {
                        sourceType: "RIMES",
                        region: clickedElement.getAttribute("data-reg"),
                        time: clickedElement.getAttribute("data-time"),
                        magnitude: clickedElement.getAttribute("data-mag"),
                        magType: clickedElement.getAttribute("data-magt"),
                        longitude: clickedElement.getAttribute("data-long"),
                        latitude: clickedElement.getAttribute("data-lat"),
                        depth: clickedElement.getAttribute("data-depth"),
                        source: sourceInfo,
                        language // pass language for PDF generation
                    };
                } else if (sourceInfo === "USGS") {
                    eventData = {
                        sourceType: "USGS",
                        title: clickedElement.getAttribute("data-title"),
                        utcTime: clickedElement.getAttribute("data-utctime"),
                        tltTime: clickedElement.getAttribute("data-tlttime"),
                        magnitude: clickedElement.getAttribute("data-magnitude"),
                        magType: clickedElement.getAttribute("data-magt"),
                        depth: clickedElement.getAttribute("data-depth"),
                        longitude: clickedElement.getAttribute("data-long"),
                        latitude: clickedElement.getAttribute("data-lat"),
                        tsunami: clickedElement.getAttribute("data-tsunami"),
                        felt: clickedElement.getAttribute("data-felt"),
                        cdi: clickedElement.getAttribute("data-cdi"),
                        mmi: clickedElement.getAttribute("data-mmi"),
                        alert: clickedElement.getAttribute("data-alert"),
                        significance: clickedElement.getAttribute("data-sig"),
                        source: "USGS",
                        language // pass language for PDF generation
                    };
                }
                generatePdfWithImage(dataUrl, eventData);
            })
            .catch((error) => {
                console.error("Failed to capture image:", error);
            });
    };


    // Updated generatePdfWithImage function with overlap fix based on page jump detection
    const generatePdfWithImage = async (dataUrl, eventData) => {
        try {
            const language = eventData.language === "tet" ? "tet" : "en";
            const isRimes = eventData.sourceType === "RIMES";
            const magnitudeDisplay = eventData.magnitude !== undefined && eventData.magnitude !== null && eventData.magnitude !== "" && !isNaN(Number(eventData.magnitude))
                ? Number(eventData.magnitude).toFixed(1) : "N/A";
            const eventTime = isRimes ? eventData.time : eventData.tltTime;

            const pdf = new jsPDF("portrait", "mm", "a4");
            await drawEarthquakeAdvisory(pdf, {
                language,
                mapDataUrl: dataUrl,
                event: {
                    headline: (isRimes ? eventData.region : eventData.title) || "",
                    detail: `Depth: ${eventData.depth} km * ${eventTime}`,
                    coords: `Lat: ${eventData.latitude} Lon: ${eventData.longitude}`,
                    magLine: `Magnitude: ${magnitudeDisplay} ${eventData.magType?.toLowerCase() === "mb" ? "SR" : (eventData.magType || "")} Source: ${eventData.source}`,
                    magnitude: magnitudeDisplay,
                    // Only USGS reports a tsunami flag; RIMES events have none.
                    tsunami: !isRimes && String(eventData.tsunami) === "1" ? "YES" : "NONE",
                },
            });
            pdf.save("DRRDSS-Earthquake-Warning.pdf");
        } catch (error) {
            console.error("Failed to load images or generate PDF:", error);
        }
    };

    const cityIcon = new L.Icon({
        iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png", // Change to your icon
        iconSize: [30, 30], // Width x Height
        iconAnchor: [15, 30], // Center the icon properly
        popupAnchor: [0, -30], // Adjust popup position
    });
    const [isInitialLoad, setIsInitialLoad] = useState(true);

    useEffect(() => {
        const fetchSettings = async () => {
            try {
                const res = await fetch(`${backendUrl}/Municipalities/save-eq-settings/`);
                if (!res.ok) throw new Error("Failed to load settings");
                const data = await res.json();
                const isValidBasemap = validBasemaps.includes(data.basemap);
                setEnableSimulation(data.enable_simulation === 'True');
                setAreaofRes(data.enable_area_of_responsibility === 'True');
                setAreaofInterest(data.enable_area_of_interest === 'True');
                set200KmBuffer(data.enable_200km_buffer === 'True');
                setUnitSource(data.enable_unit_source === 'True');
                setIOCSeaLevel(data.enable_ioc_sea_level === 'True');
                setHeatmap(data.enable_heatmap === 'True');
                setFaultLine(data.enable_fault_line === 'True');
                setSlabStrike(data.enable_slab_strike === 'True');
                setSlabDip(data.enable_slab_dip === 'True');
                setSlabDepth(data.enable_slab_depth === 'True');
                setNumberOfEQ(parseInt(data.number_of_eq));
                //setBasemap(data.basemap);
                setBasemap(isValidBasemap ? data.basemap : "White");
                setMinMagnitude(parseFloat(data.min_magnitude));
                // setEmail(data.email);

                const parsedAoi = typeof data.area_of_interest === 'string'
                    ? JSON.parse(data.area_of_interest.replace(/'/g, '"'))
                    : data.area_of_interest;

                setAoiGeoJson(parsedAoi);

                if (parsedAoi?.geometry?.coordinates) {
                    const coords = parsedAoi.geometry.coordinates[0].map(
                        ([lng, lat]) => [lat, lng]
                    );
                    setLeafletCoordinates(coords);
                }

                // ✅ Apply these only once
                if (isInitialLoad) {
                    //setBasemap(data.basemap || "White");
                    setBasemap(isValidBasemap ? data.basemap : "White");

                    setVisibleLayers({
                        "Heatmap": data.enable_heatmap === 'True',
                        "Timor-Leste": true,
                        "Area of Interest": data.enable_area_of_interest === 'True',
                        "Slab Depth": data.enable_slab_depth === 'True',
                        "Slab Dip": data.enable_slab_dip === 'True',
                        "Slab Strike": data.enable_slab_strike === 'True',
                        "Unit Sources": data.enable_unit_source === 'True',
                        "Tectonic Plate": data.enable_fault_line === 'True',
                        "IOC Sea Level": data.enable_ioc_sea_level === 'True',
                        "200Km Buffer": data.enable_200km_buffer === 'True',
                    });

                    setIsInitialLoad(false);  // Prevent re-applying defaults
                }

            } catch (error) {
                console.error("Failed to fetch settings:", error);
            }
        };

        fetchSettings();
        const intervalIdSetting = setInterval(fetchSettings, 10000);
        return () => clearInterval(intervalIdSetting);
    }, [isInitialLoad]);

    // For Heatmap - RIMES
    const fetchEvents = async () => {
        try {
            const response = await axios.get(`${backendUrl}EarthQuake/eq_events_all/`);
            setEQHistory(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching events:", error);
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchEvents();
    }, []);

    // For Heatmap - USGS
    const fetchEventsUSGS = async () => {
        try {
            const response = await axios.get(`${backendUrl}EarthQuake/eq_events_usgs_all/`);
            //const response = await axios.get(`http://127.0.0.1:8000/EarthQuake/eq_events_usgs_all/`);
            setEQHistoryUSGS(response.data);
            setLoading(false);
        } catch (error) {
            console.error("Error fetching events:", error);
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchEventsUSGS();
    }, []);
    

    // In the component body, before return:
    const [showSourceLabel] = useState(false);

    // Inside component
    const [visibleLayers, setVisibleLayers] = useState({
        "Slab Depth": false,
        "Slab Dip": false,
        "Slab Strike": false,
        "Unit Sources": false,
        "Tectonic Plate": false,
        "Heatmap": false,
        "IOC Sea Level": false,
        "200Km Buffer": false,
        "Timor-Leste": true,
        "Area of Interest": false,
    });

    const layers = Object.keys(visibleLayers).map(key => ({
        label: key,
        visible: visibleLayers[key]
    }));

    const toggleLayer = (layerName) => {
        setVisibleLayers(prev => ({
            ...prev,
            [layerName]: !prev[layerName]
        }));
    };

    return (
        <div className="wind-speed-cyclone-container">
            {/* <LiveClock/> */}
            {isSendingEmail && (
                <div className="loading-overlay above-modal">
                    <div className="spinner-border text-primary" role="status" style={{ width: "3rem", height: "3rem" }}>
                        <span className="visually-hidden">Sending Email...</span>
                    </div>
                    <p className="loading-text">Sending email, please wait...</p>
                </div>
            )}
            <Modal show={show} onHide={handleCloseModal}>
                <Modal.Header closeButton>
                    <Modal.Title>Send Advisory</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <p><strong>Region : {modalRegion}</strong></p>
                    <Form>
                        <Form.Label className="send_to">Sent To</Form.Label>
                        <Form.Select onChange={handleOptionChange}>
                            <option value="">Select an option</option>
                            <option value="1">Manual Email</option>
                            {/* <option value="2">Registered Users</option> */}
                            <option value="3">User Defined Groups</option>
                            {/* <option value="4">Alert By Location Of Users</option> */}
                        </Form.Select>
                        <br />
                        {selectedOption === '1' && (
                            <div id="manual_email_part">
                                <Form.Label className="send_to">E-mail:</Form.Label>
                                <Form.Control ref={refSentTo} type="email" placeholder="e.g. jondoe@gmail.com,janedoe@yahoo.com" />
                            </div>
                        )}
                        {selectedOption === '2' && (
                            <div>
                                <Form.Label className="send_to">Users:</Form.Label>
                                <Form.Select>
                                    <option value="">Select an User</option>
                                </Form.Select>
                            </div>
                        )}
                        {selectedOption === '3' && (
                            <div id="users_part">
                                <Form.Label className="send_to">User Group:</Form.Label>
                                <Form.Select
                                    value={selectedGroupId}
                                    onChange={async (e) => {
                                        const groupId = e.target.value;
                                        setSelectedGroupId(groupId); // Save selected group ID

                                        if (groupId) {
                                            try {
                                                const response = await axios.get(`${backendUrl}AutoEmail/get-group-emails/${groupId}/`);
                                                setGroupEmails(response.data.emails); // Save the list of emails from backend
                                            } catch (error) {
                                                alert("Failed to fetch group emails.");
                                                setGroupEmails([]);
                                            }
                                        } else {
                                            setGroupEmails([]);
                                        }
                                    }}
                                >
                                    <option value="">-- Select --</option>
                                    {emailGroups.map((groups, index) => (
                                        <option key={index} value={groups.id}>
                                            {groups.group_name}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        )}
                        {selectedOption === '4' && (
                            <div id="users_loc_part">
                                <Form.Label className="send_to">Location:</Form.Label><br />
                                <Form.Label className="Municipality">Municipality</Form.Label>
                                <Form.Select name="municipality" value={selectedMunicipality}
                                    onChange={handleMunicipalityChange} defaultValue=""
                                >
                                    <option value="" disabled hidden>Select a municipality</option>
                                    {municipalities.map((municipality, index) => (
                                        <option key={index} value={municipality.adm_code}>
                                            {municipality.adm1}
                                        </option>
                                    ))}
                                </Form.Select>
                                <Form.Label className="Sub Municipality">Municipality:</Form.Label>
                                <Form.Select
                                    name="sub_municipality"
                                    disabled={!selectedMunicipality}
                                    defaultValue=""
                                >
                                    <option value="" disabled hidden>
                                        {selectedMunicipality
                                            ? "Select a sub-municipality"
                                            : "Select a municipality first"}
                                    </option>
                                    {subMunicipalities.map((submunicipality, index) => (
                                        <option key={index} value={submunicipality.adm_code}>
                                            {submunicipality.adm2}
                                        </option>
                                    ))}
                                </Form.Select>
                            </div>
                        )}
                        <br />
                        {selectedOption !== '' && (
                            <div id="message_part">
                                <div className="row">
                                    <Form.Label className="send_to col-md-2">Message:</Form.Label><br />
                                    <div className="col-md-8">
                                        <div className="form-group has-feedback">
                                            <textarea className="textarea" ref={refMessage} cols="40" rows="10" name="message" id="message" value={modal_message_info} placeholder="Fill additional message here." readOnly={true}>
                                                {modal_message_info}
                                            </textarea>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}> Cancel </Button>
                    <Button variant="primary" onClick={sendEmail}> Send </Button>
                </Modal.Footer>
            </Modal>
            <div className="grid grid-cols-1 gap-4">
                {sources[selectedSource].map((source, index) => {
                    //console.log(`Rendering ${source.name} information`);
                  
                    return (
                        <div key={index} className="p-1">
                            {selectedSource === "RIMES" &&
                                <div>
                                    {/* Statistics Section Above Map */}
                                    {reEqdata && reEqdata.length > 0 && (
                                        <div style={{ 
                                            backgroundColor: '#ffffff',
                                            borderRadius: '16px',
                                            padding: '12px',
                                            marginBottom: '12px',
                                            border: '1px solid #e0e0e0',
                                            marginLeft: '8px',
                                            marginRight: '8px',
                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                            alignItems: 'center',
                                            gap: 2,
                                        }}>
                                        <div style={{ marginBottom: '8px' }}>
                                                <div style={{
                                                    fontSize: '18px',
                                                    fontWeight: '700',
                                                    color: '#1976d2',
                                                    marginBottom: '8px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                }}>
                                                    <span>Total: {numberOfEQ ? reEqdata.slice(0, numberOfEQ).length : reEqdata.length} Events</span>
                                                    {reEqdata && reEqdata.length > 0 && (
                                                        <span style={{
                                                            fontSize: '13px',
                                                            fontWeight: '600',
                                                            color: '#666',
                                                            backgroundColor: '#f5f7fa',
                                                            padding: '4px 12px',
                                                            borderRadius: '4px'
                                                        }}>
                                                            Period: {moment.utc((numberOfEQ ? reEqdata.slice(0, numberOfEQ) : reEqdata)[(numberOfEQ ? reEqdata.slice(0, numberOfEQ) : reEqdata).length - 1]?.event_datetime).tz('Asia/Dili').format('DD MMM YYYY')} - {moment.utc((numberOfEQ ? reEqdata.slice(0, numberOfEQ) : reEqdata)[0]?.event_datetime).tz('Asia/Dili').format('DD MMM YYYY')}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            
                                            {/* Magnitude Breakdown - Single Row */}
                                            <div style={{ 
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '8px',
                                                fontSize: '18px'
                                            }}>
                                                {[
                                                    { label: '7.0+', min: 7.0, color: 'red' },
                                                    { label: '6.0-6.9', min: 6.0, max: 6.9, color: '#f6ad55' },
                                                    { label: '5.0-5.9', min: 5.0, max: 5.9, color: '#f6e05e' },
                                                    { label: '4.0-4.9', min: 4.0, max: 4.9, color: '#68d391' },
                                                    { label: '<4.0', max: 3.9, color: '#4299e1' }
                                                ].map((range) => {
                                                    const count = (numberOfEQ ? reEqdata.slice(0, numberOfEQ) : reEqdata).filter(event => {
                                                        const mag = parseFloat(event.magnitude);
                                                        if (range.min && range.max) return mag >= range.min && mag <= range.max;
                                                        if (range.min) return mag >= range.min;
                                                        if (range.max) return mag <= range.max;
                                                        return false;
                                                    }).length;
                                                    
                                                    return (
                                                        <div 
                                                            key={range.label}
                                                            style={{ 
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '4px',
                                                                padding: '4px 8px',
                                                                backgroundColor: '#f1f2f5',
                                                                borderRadius: '4px',
                                                                border: `1px solid #f1f2f5`,
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: '12px',
                                                                    height: '12px',
                                                                    backgroundColor: range.color,
                                                                    borderRadius: '2px',
                                                                    flexShrink: 0,
                                                                    boxShadow: `0 2px 4px ${range.color}40`
                                                                }}
                                                            />
                                                            <span style={{ color: '#666', fontWeight: '600' }}>
                                                                {range.label}
                                                            </span>
                                                            <span style={{ 
                                                                color: range.color,
                                                                fontWeight: '700'
                                                            }}>
                                                                ({count})
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div className="row">
                                        <div className="relative h-[650px] col-md-9" ref={mapRef} style={{ position: 'relative', height: '650px', overflow: 'hidden', borderRadius: '12px' }}>
                                            {/* <MapFilterControl onApply={handleFilterUpdate} /> */}
                                            <WindyInfoButton infoText={"The heatmap is generated using historical earthquake events along with their magnitudes, and it is updated daily by adding newly occurring events from around the world."} />
                                            <MapContainer
                                                center={center}
                                                attributionControl={false}
                                                zoomControl={false}
                                                zoom={INITIAL_VIEW_STATE.zoom}
                                                style={{ width: "100%", height: "650px", borderRadius: '12px' }}
                                                className="w-full h-full z-0"
                                            >
                                              <MapHomeControl />
                                                {/* Dynamic Base Map */}
                                                {basemap && <DynamicTileLayer basemap={basemap} />}

                                                {/* Heatmap Layer */}
                                                {visibleLayers["Heatmap"] && EQHistory && (
                                                    <HeatmapLayer data={EQHistory} visible={true} />
                                                )}

                                                {/* Timor-Leste Boundary */}
                                                {visibleLayers["Timor-Leste"] && boundaryData && (
                                                    <GeoJSON
                                                        data={boundaryData}
                                                        style={{
                                                            color: "#000000",
                                                            weight: 1,
                                                            opacity: 0.8,
                                                            fillOpacity: 0,
                                                        }}
                                                    />
                                                )}

                                            {/* Area of Interest */}
                                            {visibleLayers["Area of Interest"] && leafletCoordinates.length > 0 && (
                                                <Polygon
                                                    positions={leafletCoordinates}
                                                    pathOptions={{
                                                        fillColor: "#ebdc13",
                                                        color: "#ebdc13",
                                                        opacity: 1,
                                                        fillOpacity: 0,
                                                        weight: 2,
                                                    }}
                                                />
                                            )}

                                            {/* Slab Depth */}
                                            {selFeDepth && (
                                                <div
                                                    className="hoverFeatureEQ"
                                                    dangerouslySetInnerHTML={{ __html: selFeDepth }}
                                                />
                                            )}
                                            {visibleLayers["Slab Depth"] && slab_depth && (
                                                <GeoJSON
                                                    data={slab_depth}
                                                    style={styleDepth}
                                                    onEachFeature={onEachFeatureSlabDepth}
                                                />
                                            )}

                                            {/* Slab Dip */}
                                            {selFeDIP && (
                                                <div
                                                    className="hoverFeatureEQ"
                                                    dangerouslySetInnerHTML={{ __html: selFeDIP }}
                                                />
                                            )}
                                            {visibleLayers["Slab Dip"] && slab_dip && (
                                                <GeoJSON
                                                    data={slab_dip}
                                                    style={styleDip}
                                                    onEachFeature={onEachFeatureSlabDip}
                                                />
                                            )}

                                            {/* Slab Strike */}
                                            {selFeStrike && (
                                                <div
                                                    className="hoverFeatureEQ"
                                                    dangerouslySetInnerHTML={{ __html: selFeStrike }}
                                                />
                                            )}
                                            {visibleLayers["Slab Strike"] && slab_strike && (
                                                <GeoJSON
                                                    data={slab_strike}
                                                    style={styleStrike}
                                                    onEachFeature={onEachFeatureSlabStrike}
                                                />
                                            )}

                                            {/*  Unit Sources */}
                                            {visibleLayers["Unit Sources"] && Unit_Source && (
                                                <GeoJSON data={Unit_Source} style={styleUnitSources} />
                                            )}

                                            {/* Tectonic Plate */}
                                            {visibleLayers["Tectonic Plate"] && tectonicPlate && (
                                                <GeoJSON data={tectonicPlate} style={styleTectonicPlate} />
                                            )}

                                            {/* IOC Sea Level */}
                                            {visibleLayers["IOC Sea Level"] && L_IOC && (
                                                <GeoJSON
                                                    data={L_IOC}
                                                    pointToLayer={(feature, latlng) =>
                                                        L.marker(latlng, { icon: customIcon })
                                                    }
                                                    onEachFeature={(feature, layer) => {
                                                        if (feature.properties.name) {
                                                            const des = feature.properties.description.value;
                                                            layer.bindPopup(
                                                                `<strong>${feature.properties.name}</strong><br/>${des}`,
                                                                { className: "ioc_sea_popup" }
                                                            );
                                                        }
                                                    }}
                                                />
                                            )}

                                                {/* 200Km Buffer */}
                                                {visibleLayers["200Km Buffer"] && buffer200 && (
                                                    <GeoJSON
                                                        data={buffer200}
                                                        style={{
                                                            color: "orange",
                                                            weight: 3,
                                                            opacity: 1,
                                                            fillOpacity: 0,
                                                        }}
                                                    />
                                                )}

                                                {/* Quake Markers */}
                                                <EarthquakeMarkers
                                                    reEqdata={numberOfEQ ? reEqdata.slice(0, numberOfEQ) : reEqdata}
                                                    compute_magnitude={compute_magnitude}
                                                    getDistance={getDistance}
                                                    handleShowModal={handleShowModal}
                                                    setClickedEventElement={setClickedEventElement}
                                                    setShowLanguageModal={setShowLanguageModal}
                                                    markerRefs={markerRefs}
                                                    canSendEmail={canSendEmail}
                                                    canGenerateBulletin={canGenerateBulletin}
                                                />

                                                {/* Extras */}
                                                <ScaleControl position="bottomleft" />
                                                <Legend position="bottomleft" />
                                                <HoverCoordinates setCoordinates={setCoordinates} />

                                                {/* 🌐 Source Selector */}
                                                <div
                                                    className="source-btns-windy"
                                                // onMouseEnter={() => setShowSourceLabel(true)}
                                                // onMouseLeave={() => setShowSourceLabel(false)}
                                                >
                                                    {showSourceLabel && (
                                                        <span className="source-label-hover-abs-left">Source</span>
                                                    )}
                                                    <div className="source-toggle-pill">
                                                        <button
                                                            className={`source-pill-btn${selectedSource === "RIMES" ? " active" : ""
                                                                }`}
                                                            onClick={() => {
                                                                setSelectedSource("RIMES");
                                                                setShowModal(false);
                                                            }}
                                                        >
                                                            RIMES
                                                        </button>
                                                        <button
                                                            className={`source-pill-btn${selectedSource === "USGS" ? " active" : ""
                                                                }`}
                                                            onClick={() => setSelectedSource("USGS")}
                                                        >
                                                            USGS
                                                        </button>
                                                    </div>
                                                </div>
                                            </MapContainer>
                                        <BaseMapLayerControl
                                            layers={layers}
                                            toggleLayer={toggleLayer}
                                            basemap={basemap}
                                            setBasemap={setBasemap}
                                        />
                                        <div className="coordinates-display">
                                            {coordinates.lat && coordinates.lng ? (
                                                <p> Latitude: {coordinates.lat}, Longitude: {coordinates.lng} </p>
                                            ) : (
                                                <p></p>
                                            )}
                                        </div>

                                    </div>
                                    <div className="col-md-3 recenteqlist">
                                        <div className="event-list" style={{ padding: "8px" }}>
                                            <ul className="eq-list" style={{ overflowY: 'auto', width: 'auto', height: '740px', paddingLeft: '0', marginBottom: '0' }}>
                                                {reEqdata &&
                                                    (numberOfEQ ? reEqdata.slice(0, numberOfEQ) : reEqdata).map((event, index) => (
                                                        <li id={`tr${event.event_id}`} key={event.event_id} data-id={`${event.event_id}`} className={`li-event ${(index === selectedEventIndex ? 'selected' : '')}`} onClick={() => setSelectedEventIndex(index)}>
                                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                                <tbody>
                                                                    <tr key={event.id} onClick={() => handleExternalClick(index)} style={{ verticalAlign: 'top' }}>
                                                                        <td style={{ width: '85px', paddingRight: '12px' }}>
                                                                            <div 
                                                                                className="eq-mag" 
                                                                                style={{ 
                                                                                    color: '#fff', 
                                                                                    backgroundColor: getColor(event.magnitude),
                                                                                    minWidth: '70px',
                                                                                    minHeight: '70px',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    fontSize: '22px',
                                                                                    fontWeight: '700',
                                                                                    lineHeight: '1',
                                                                                    boxShadow: `0 4px 12px ${getColor(event.magnitude)}40`,
                                                                                    transition: 'all 0.3s ease',
                                                                                    borderRadius: '50%'
                                                                                }}
                                                                            >
                                                                                {parseFloat(event.magnitude).toFixed(1)}
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ paddingRight: '8px', flex: 1 }}>
                                                                            <div style={{ marginBottom: '12px' }}>
                                                                                <div className="event_header">
                                                                                    <h5 
                                                                                        className="h5_event" 
                                                                                        style={{ 
                                                                                            color: getColor(event.magnitude),
                                                                                            marginTop: '4px',
                                                                                            marginBottom: '8px',
                                                                                            fontSize: '15px',
                                                                                            fontWeight: '700',
                                                                                            letterSpacing: '0.3px',
                                                                                            lineHeight: '1.3'
                                                                                        }}
                                                                                    >
                                                                                        {event.region}
                                                                                    </h5>
                                                                                </div>
                                                                                <span 
                                                                                    className="eq-other-txt" 
                                                                                    style={{
                                                                                        color: '#A5A5A5',
                                                                                        fontSize: '12px',
                                                                                        display: 'block',
                                                                                        lineHeight: '1.4',
                                                                                        marginBottom: '3px'
                                                                                    }}
                                                                                >
                                                                                    <strong style={{ color: '#666' }}>OT:</strong> {moment.utc(event.event_datetime).tz('Asia/Dili').format('DD MMM YYYY hh:mm:ss A')}
                                                                                </span>
                                                                                <span 
                                                                                    className="eq-other-txt" 
                                                                                    style={{
                                                                                        color: '#A5A5A5',
                                                                                        fontSize: '12px',
                                                                                        display: 'block',
                                                                                        lineHeight: '1.4'
                                                                                    }}
                                                                                >
                                                                                    <strong style={{ color: '#666' }}>Depth:</strong> {event.depth} KM
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                            {selectedSource === "USGS" &&
                                <div>
                                    {/* Statistics Section Above Map */}
                                    {reEqUSGSdata && reEqUSGSdata.length > 0 && (
                                        <div style={{ 
                                            backgroundColor: '#ffffff',
                                            borderRadius: '16px',
                                            padding: '12px',
                                            marginBottom: '12px',
                                            border: '1px solid #e0e0e0',
                                            marginLeft: '8px',
                                            marginRight: '8px',
                                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                            alignItems: 'center',
                                            gap: 2,
                                        }}>
                                            <div style={{ marginBottom: '8px' }}>
                                               
                                                <div style={{
                                                    fontWeight: '700',
                                                    color: '#1976d2',
                                                    marginBottom: '8px',
                                                    fontSize: '18px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                }}>
                                                    <span>Total: {numberOfEQ ? reEqUSGSdata.slice(0, numberOfEQ).length : reEqUSGSdata.length} Events</span>
                                                    {reEqUSGSdata && reEqUSGSdata.length > 0 && (
                                                        <span style={{
                                                            fontSize: '13px',
                                                            fontWeight: '600',
                                                            color: '#666',
                                                            backgroundColor: '#f5f7fa',
                                                            padding: '4px 12px',
                                                            borderRadius: '4px'
                                                        }}>
                                                            Period: {moment.utc((numberOfEQ ? reEqUSGSdata.slice(0, numberOfEQ) : reEqUSGSdata)[(numberOfEQ ? reEqUSGSdata.slice(0, numberOfEQ) : reEqUSGSdata).length - 1]?.time_in_utc).tz('Asia/Dili').format('DD MMM YYYY')} - {moment.utc((numberOfEQ ? reEqUSGSdata.slice(0, numberOfEQ) : reEqUSGSdata)[0]?.time_in_utc).tz('Asia/Dili').format('DD MMM YYYY')}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                            
                                            {/* Magnitude Breakdown - Single Row */}
                                            <div style={{ 
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '8px',
                                                fontSize: '18px'
                                            }}>
                                                {[
                                                    { label: '7.0+', min: 7.0, color: 'red' },
                                                    { label: '6.0-6.9', min: 6.0, max: 6.9, color: '#f6ad55' },
                                                    { label: '5.0-5.9', min: 5.0, max: 5.9, color: '#f6e05e' },
                                                    { label: '4.0-4.9', min: 4.0, max: 4.9, color: '#68d391' },
                                                    { label: '<4.0', max: 3.9, color: '#4299e1' }
                                                ].map((range) => {
                                                    const count = (numberOfEQ ? reEqUSGSdata.slice(0, numberOfEQ) : reEqUSGSdata).filter(event => {
                                                        const mag = parseFloat(event.magnitude);
                                                        if (range.min && range.max) return mag >= range.min && mag <= range.max;
                                                        if (range.min) return mag >= range.min;
                                                        if (range.max) return mag <= range.max;
                                                        return false;
                                                    }).length;
                                                    
                                                    return (
                                                        <div 
                                                            key={range.label}
                                                            style={{ 
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '4px',
                                                                padding: '4px 8px',
                                                                backgroundColor: '#f1f2f5',
                                                                borderRadius: '4px',
                                                                border: `1px solid #f1f2f5`,
                                                                whiteSpace: 'nowrap'
                                                            }}
                                                        >
                                                            <div
                                                                style={{
                                                                    width: '12px',
                                                                    height: '12px',
                                                                    backgroundColor: range.color,
                                                                    borderRadius: '2px',
                                                                    flexShrink: 0,
                                                                    boxShadow: `0 2px 4px ${range.color}40`
                                                                }}
                                                            />
                                                            <span style={{ color: '#666', fontWeight: '600' }}>
                                                                {range.label}
                                                            </span>
                                                            <span style={{ 
                                                                color: range.color,
                                                                fontWeight: '700'
                                                            }}>
                                                                ({count})
                                                            </span>
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    )}
                                    
                                    <div className="row">
                                        <div className="relative h-[650px] col-md-9" ref={mapRef} style={{ position: 'relative', height: '650px', overflow: 'hidden', borderRadius: '12px' }}>
                                            {/* <MapFilterControl onApply={handleFilterUpdate} /> */}
                                            <WindyInfoButton infoText={"The heatmap is generated using historical earthquake events along with their magnitudes, and it is updated daily by adding newly occurring events from around the world."} />
                                            <MapContainer
                                                center={center}
                                                attributionControl={false}
                                                zoomControl={false}
                                                zoom={INITIAL_VIEW_STATE.zoom}
                                                style={{ width: "100%", height: "650px", borderRadius: '12px' }}
                                                className="w-full h-full z-0"
                                            >
                                              <MapHomeControl />

                                                {/* Dynamic Base Map */}
                                                {basemap && <DynamicTileLayer basemap={basemap} />}

                                            {/* Heatmap Layer */}
                                            {visibleLayers["Heatmap"] && EQHistoryUSGS && (
                                                <HeatmapLayer data={EQHistoryUSGS} visible={true} />
                                            )}


                                            {/* Timor-Leste Boundary */}
                                            {visibleLayers["Timor-Leste"] && boundaryData && (
                                                <GeoJSON
                                                    data={boundaryData}
                                                    style={{
                                                        color: "#000000",
                                                        weight: 1,
                                                        opacity: 0.8,
                                                        fillOpacity: 0,
                                                    }}
                                                />
                                            )}

                                            {/* Area of Interest */}
                                            {visibleLayers["Area of Interest"] && leafletCoordinates.length > 0 && (
                                                <Polygon
                                                    positions={leafletCoordinates}
                                                    pathOptions={{
                                                        fillColor: "#ebdc13",
                                                        color: "#ebdc13",
                                                        opacity: 1,
                                                        fillOpacity: 0,
                                                        weight: 2,
                                                    }}
                                                />
                                            )}

                                            {/* Slab Depth */}
                                            {selFeDepth && (
                                                <div
                                                    className="hoverFeatureEQ"
                                                    dangerouslySetInnerHTML={{ __html: selFeDepth }}
                                                />
                                            )}
                                            {visibleLayers["Slab Depth"] && slab_depth && (
                                                <GeoJSON
                                                    data={slab_depth}
                                                    style={styleDepth}
                                                    onEachFeature={onEachFeatureSlabDepth}
                                                />
                                            )}

                                            {/* Slab Dip */}
                                            {selFeDIP && (
                                                <div
                                                    className="hoverFeatureEQ"
                                                    dangerouslySetInnerHTML={{ __html: selFeDIP }}
                                                />
                                            )}
                                            {visibleLayers["Slab Dip"] && slab_dip && (
                                                <GeoJSON
                                                    data={slab_dip}
                                                    style={styleDip}
                                                    onEachFeature={onEachFeatureSlabDip}
                                                />
                                            )}

                                            {/* Slab Strike */}
                                            {selFeStrike && (
                                                <div
                                                    className="hoverFeatureEQ"
                                                    dangerouslySetInnerHTML={{ __html: selFeStrike }}
                                                />
                                            )}
                                            {visibleLayers["Slab Strike"] && slab_strike && (
                                                <GeoJSON
                                                    data={slab_strike}
                                                    style={styleStrike}
                                                    onEachFeature={onEachFeatureSlabStrike}
                                                />
                                            )}

                                            {/*  Unit Sources */}
                                            {visibleLayers["Unit Sources"] && Unit_Source && (
                                                <GeoJSON data={Unit_Source} style={styleUnitSources} />
                                            )}

                                            {/* Tectonic Plate */}
                                            {visibleLayers["Tectonic Plate"] && tectonicPlate && (
                                                <GeoJSON data={tectonicPlate} style={styleTectonicPlate} />
                                            )}

                                            {/* IOC Sea Level */}
                                            {visibleLayers["IOC Sea Level"] && L_IOC && (
                                                <GeoJSON
                                                    data={L_IOC}
                                                    pointToLayer={(feature, latlng) =>
                                                        L.marker(latlng, { icon: customIcon })
                                                    }
                                                    onEachFeature={(feature, layer) => {
                                                        if (feature.properties.name) {
                                                            const des = feature.properties.description.value;
                                                            layer.bindPopup(
                                                                `<strong>${feature.properties.name}</strong><br/>${des}`,
                                                                { className: "ioc_sea_popup" }
                                                            );
                                                        }
                                                    }}
                                                />
                                            )}

                                                {/* 200Km Buffer */}
                                                {visibleLayers["200Km Buffer"] && buffer200 && (
                                                    <GeoJSON
                                                        data={buffer200}
                                                        style={{
                                                            color: "orange",
                                                            weight: 3,
                                                            opacity: 1,
                                                            fillOpacity: 0,
                                                        }}
                                                    />
                                                )}
                                                {/* Quake Markers */}
                                                <EarthquakeMarkersUSGS
                                                    reEqdata={numberOfEQ ? reEqUSGSdata.slice(0, numberOfEQ) : reEqUSGSdata}
                                                    compute_magnitudeUSGS={compute_magnitudeUSGS}
                                                    getDistance={getDistance}
                                                    handleShowModal={handleShowModal}
                                                    setClickedEventElement={setClickedEventElement}
                                                    setShowLanguageModal={setShowLanguageModal}
                                                    markerRefs={markerRefs}
                                                    fetchNearbyCities={fetchNearbyCities}
                                                    canSendEmail={canSendEmail}
                                                    canGenerateBulletin={canGenerateBulletin}
                                                />

                                                {/* Mark nearby cities */}
                                                {nearbyCities.map((city, index) => (
                                                    <Marker key={index} position={[city.latitude, city.longitude]} icon={cityIcon}>
                                                        <Popup><strong>{city.name}</strong> - {city.direction} ({city.distance} km)</Popup>
                                                    </Marker>
                                                ))}
                                                <ScaleControl position="bottomleft" />
                                                <LegendUSGS position="bottomleft" />
                                                <HoverCoordinates setCoordinates={setCoordinates} />
                                                {/* Windy-style source selector inside the map for USGS */}
                                                <div className="source-btns-windy"
                                                // onMouseEnter={() => setShowSourceLabel(true)}
                                                // onMouseLeave={() => setShowSourceLabel(false)}
                                                >
                                                    {showSourceLabel && (
                                                        <span className="source-label-hover-abs-left">Source</span>
                                                    )}
                                                    <div className="source-toggle-pill">
                                                        <button
                                                            className={`source-pill-btn${selectedSource === "RIMES" ? " active" : ""}`}
                                                            onClick={() => {
                                                                setSelectedSource("RIMES");
                                                                // setShowModal(false);
                                                            }}
                                                        >
                                                            RIMES
                                                        </button>
                                                        <button
                                                            className={`source-pill-btn${selectedSource === "USGS" ? " active" : ""}`}
                                                            onClick={() => setSelectedSource("USGS")}
                                                        >
                                                            USGS
                                                        </button>
                                                    </div>
                                                </div>
                                            </MapContainer>
                                        <BaseMapLayerControl
                                            layers={layers}
                                            toggleLayer={toggleLayer}
                                            basemap={basemap}
                                            setBasemap={setBasemap}
                                        />
                                        <div className="coordinates-display">
                                            {coordinates.lat && coordinates.lng ? (
                                                <p> Latitude: {coordinates.lat}, Longitude: {coordinates.lng} </p>
                                            ) : (
                                                <p></p>
                                            )}
                                        </div>

                                    </div>
                                    <div className="col-md-3 recenteqlist">
                                        <div className="event-list">
                                            <ul className="eq-list" style={{ overflowY: 'auto', width: 'auto', height: '740px', paddingLeft: '0', marginBottom: '0' }}>
                                                {reEqUSGSdata &&
                                                    (numberOfEQ ? reEqUSGSdata.slice(0, numberOfEQ) : reEqUSGSdata).map((event, index) => (
                                                        <li id={`tr${event.event_id}`} key={event.event_id} data-id={`${event.event_id}`} className={`li-event ${(index === selectedEventIndex ? 'selected' : '')}`} onClick={() => setSelectedEventIndex(index)}>
                                                            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                                                <tbody>
                                                                    <tr key={event.id} onClick={() => handleExternalClick(index)} style={{ verticalAlign: 'top' }}>
                                                                        <td style={{ width: '85px', paddingRight: '12px' }}>
                                                                            <div 
                                                                                className="eq-mag" 
                                                                                style={{ 
                                                                                    color: '#fff', 
                                                                                    backgroundColor: getColorUSGS(event.magnitude),
                                                                                    minWidth: '70px',
                                                                                    minHeight: '70px',
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    justifyContent: 'center',
                                                                                    fontSize: '22px',
                                                                                    fontWeight: '700',
                                                                                    lineHeight: '1',
                                                                                    boxShadow: `0 4px 12px ${getColorUSGS(event.magnitude)}40`,
                                                                                    transition: 'all 0.3s ease',
                                                                                    borderRadius: '50%'
                                                                                }}
                                                                            >
                                                                                {parseFloat(event.magnitude).toFixed(1)}
                                                                            </div>
                                                                        </td>
                                                                        <td style={{ paddingRight: '8px', flex: 1 }}>
                                                                            <div style={{ marginBottom: '12px' }}>
                                                                                <div className="event_header">
                                                                                    <h5 
                                                                                        className="h5_event" 
                                                                                        style={{ 
                                                                                            color: getColorUSGS(event.magnitude),
                                                                                            marginTop: '4px',
                                                                                            marginBottom: '8px',
                                                                                            fontSize: '15px',
                                                                                            fontWeight: '700',
                                                                                            letterSpacing: '0.3px',
                                                                                            lineHeight: '1.3'
                                                                                        }}
                                                                                    >
                                                                                        {event.status === "reviewed" && <Check size={15} color="blue" style={{ marginRight: '4px' }} />} 
                                                                                        {event.title}
                                                                                    </h5>
                                                                                </div>
                                                                                <span 
                                                                                    className="eq-other-txt" 
                                                                                    style={{
                                                                                        color: '#A5A5A5',
                                                                                        fontSize: '12px',
                                                                                        display: 'block',
                                                                                        lineHeight: '1.4',
                                                                                        marginBottom: '3px'
                                                                                    }}
                                                                                >
                                                                                    <strong style={{ color: '#666' }}>OT:</strong> {moment.utc(event.time_in_utc).tz('Asia/Dili').format('DD MMM YYYY hh:mm:ss A')}
                                                                                </span>
                                                                                <span 
                                                                                    className="eq-other-txt" 
                                                                                    style={{
                                                                                        color: '#A5A5A5',
                                                                                        fontSize: '12px',
                                                                                        display: 'block',
                                                                                        lineHeight: '1.4'
                                                                                    }}
                                                                                >
                                                                                    <strong style={{ color: '#666' }}>Depth:</strong> {event.depth} KM
                                                                                </span>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                    );
                })}
            </div>
            {showFlashMsg && (
                <div
                    className="alert alert-warning fade show position-fixed"
                    role="alert"
                    style={{
                        top: "20px",
                        right: "20px",
                        minWidth: "250px",
                        zIndex: 1050,
                        transition: "opacity 0.5s ease-out",
                    }}
                >
                    No nearby cities found!
                    <button type="button" className="btn-close btn-sm" size="sm" onClick={() => setShowFlashMsg(false)}></button>
                </div>
            )}
            <LanguageModal
                show={showLanguageModal}
                onClose={() => setShowLanguageModal(false)}
                onSelectLanguage={handleLanguageSelection}
            />
        </div>
    );
};
export default RecentEarthquake;